import { useList } from '@refinedev/core';
import { User, UserRole } from '../types';

export default function useUsers(includedUserRoles: UserRole[] = [], skip: boolean = false) {
  const { data, isLoading, refetch, isError } = useList<User>({
    resource: 'users',
    queryOptions: {
      enabled: !skip,
    },
  });

  // TODO: this filtering should be done on the server side
  const filteredUsers = data?.data.filter(user => {
    if (includedUserRoles.length === 0) return true; // If no types are specified, return all users
    return includedUserRoles.includes(user.userRole);
  });

  return {
    users: filteredUsers || [],
    isLoading,
    refetch,
    isError,
  };
}
